// extracted by mini-css-extract-plugin
export var paginationCurrent = "index-module--pagination-current--99fcd";
export var thumbsSwiper = "index-module--thumbs-swiper--1385e";